import clsx from "clsx";
import { navigate } from "gatsby";
import React, { FC } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { usePageFullPath } from "../../../../hooks/use-page-full-path";
import { IconButton } from "../../../buttons/icon-button";
import { LocaleSelectorTag } from "../../common/locale-selector-tag";
import { HeaderMenuSpecialItems } from "../../types";

export interface HeaderMenuActionsProps {
  className?: string;
}

export const HeaderMenuActions: FC<HeaderMenuActionsProps> = ({ className }) => {
  const {
    toggleExpandedItemId,
    setItemPanelExpanded,
    headerMenu: { node_locale, storeLocatorPage },
  } = useHeaderMenu();

  const storeLocatorFullPath = usePageFullPath(storeLocatorPage?.id);

  return (
    <div className={clsx("flex items-center justify-between gap-2", className)}>
      <div className="flex items-center gap-2">
        {storeLocatorFullPath && (
          <IconButton
            icon="map-pin"
            onClick={() => {
              setItemPanelExpanded(false);
              navigate(storeLocatorFullPath);
            }}
            variant="light"
            size="small"
          />
        )}
        <IconButton
          icon="search"
          onClick={() => toggleExpandedItemId(HeaderMenuSpecialItems.Search)}
          variant="light"
          size="small"
        />
        <IconButton
          icon="profile"
          onClick={() => toggleExpandedItemId(HeaderMenuSpecialItems.PersonalArea)}
          variant="light"
          size="small"
        />
      </div>
      <div className="pr-4 text-light">
        <LocaleSelectorTag
          locale={node_locale}
          onClick={() => toggleExpandedItemId(HeaderMenuSpecialItems.LocaleSelector)}
          variant="light"
        />
      </div>
    </div>
  );
};
